import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, Row, Col } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import TableWidget from "./TableWidget/TableWidget";
import { showAddUnitDialog } from "./AddUnitDialog/showAddUnitDialog";
import {
  apiGetUnitList,
  apiCreateUnit,
  apiUpdateUnit,
  apiDeleteUnit,
} from "services/shopUnitService";

function ShopUnitListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);

  const loadUnits = () => {
    setIsBusy(true);
    apiGetUnitList()
      .then((data) => {
        setIsBusy(false);
        setDataList(data || []);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        message.error("Sorry! " + err);
      });
  };

  useEffect(() => {
    loadUnits();
  }, []);

  const onNewUnit = async () => {
    var res = await showAddUnitDialog({ title: "New Unit", isEditing: false });
    if (res === null) return;
    setIsBusy(true);
    apiCreateUnit(res)
      .then((data) => {
        setIsBusy(false);
        setDataList([...dataList, data]);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };

  const onClickEdit = async (pInfo) => {
    var res = await showAddUnitDialog({ title: "Edit Unit", record: pInfo, isEditing: true });
    if (res === null) return;
    setIsBusy(true);
    apiUpdateUnit(pInfo.id, res)
      .then((data) => {
        setIsBusy(false);
        let updateData = [...dataList];
        var idx = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(idx, 1, data);
        setDataList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeleteUnit(pInfo.id)
      .then(() => {
        setIsBusy(false);
        setDataList(dataList.filter((x) => x.id != pInfo.id));
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Units</h1>
        <Row>
          <Col flex={"auto"} />
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton onClick={onNewUnit}>New</CommonButton>
            </div>
          </Col>
        </Row>

        <div style={{ paddingTop: 16 }}>
          <TableWidget dataList={dataList} onUpdateAction={onClickEdit} onDeleteAction={onClickDelete} />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopUnitListPage;
